import { useEffect, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const F_CA: React.FC = () => {
    const { t } = useLang('dpux');
    const webOrJpg = useWebpOrJpg('#delta-pro-ultra-x-F');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        const ani = AniContainer.create({
            triggerElement: '#delta-pro-ultra-x-F',
            triggerHook: 1,
            offset: '30%',
            duration: '130%',
            onEnter: () => {
                setTextEnter(true);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    setTextEnter(false);
                }
            },
        });

        return () => {
            ani.destroy();
        };
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-F GtmModuleData-section`}
            id="delta-pro-ultra-x-F"
            data-section-id={'delta-pro-ultra-x-F'}
            data-section-title={t('F_title')}
        >
            <div className="sticky">
                <EcoImg
                    className="bg-img"
                    pc={webOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762483566973/F.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1762483566301/F.webp',
                    )}
                    h5={webOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762483566507/F-m.webp',
                        'https://websiteoss.ecoflow.com/upload/image/1762483566757/F-m.jpg',
                    )}
                />
                <ul className={`items${textEnter ? ' enter' : ''}`}>
                    {[1, 2, 3, 4].map((item) => (
                        <li className="item" key={item}>
                            <div className="item-name">
                                {t.rich(`F_item${item}_name`, {
                                    s: (v: string) => <span className="s">{v}</span>,
                                })}
                            </div>
                            <p className="item-line"></p>
                            <div className="item-text">{t(`F_item${item}_text`)}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default F_CA;
